module.exports = __webpack_public_path__ + "static/img/login_bg.7936e3af.png";